import { CModal,CModalHeader,CModalBody,CModalTitle,CModalFooter,CButton,CForm } from '@coreui/react'
import { Modal } from 'bootstrap';
import {CFormTextarea,CFormCheck}  from '@coreui/react';
import React, { useEffect,useState } from "react";
import Dropdown from 'react-dropdown';

const MyModal = (props) => {

const [visible, setVisible] = useState(false);

const [data,setData] = useState(props.data.items);
const [dpi,setDpi] = useState(props.data.dpi);

const [currentDpi,setCurrentDpi] = useState(props.data.currentDpi);


useEffect(() => {
  setDpi(props.data.dpi);
  setCurrentDpi(props.data.currentDpi);

}, [props.data.dpi,props.data.currentDpi])



const handleConfirm = () => {
  props.myFunction(data,props.tipologia);
 
  setVisible(!visible)
}


const handleChange = (e,id) =>{
  var value = "";

  e.hasOwnProperty('target')?(value = e.target.value):(value=e.value);


  var items = [...data]; // popolo l'array 

console.log(value)
  items = data.map((x) => { //<- cerco con il map l'elemento e gli aggiungo il value
    if (x.id === id){
     // console.log(e.target.value);
     x.val = value;
    }
     return x;
  });
  setData(items);

}

const handleConfirmCheckbox = () => {

  props.myFunction(currentDpi,props.data.name,props.data.index);


}

const Renderswitch =(item) => {
  let c =""
  let contenuto = []
switch(item.text){

case "Note":
 
      c= <CFormTextarea style={{height:"38px"}} type="text" name={item.text} value={item.val} className="form-control form-control-lg"  onChange={(e) => handleChange(e,item.id)}/>
  return c;
break;
case "Macchina / Attrezzatura":
 
     c = <input type="text" name={item.text} value={item.val} className="form-control form-control-lg"  onChange={(e) => handleChange(e,item.id)}/>
      return c;
break;
case "Ubicazione":

     c =<Dropdown name="Ubicazione" options={props.data.luoghi.length===0?[]:props.data.luoghi.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
  })} value={(item.val)} onChange={(e) => handleChange(e,item.id)} placeholder="Seleziona..." />
      return c;
break;

case "Mansione":
 
     c =<Dropdown name="Mansione" value={(item.val)} onChange={(e) => handleChange(e,item.id)}  options={props.data.mansioni.filter(function(elem, index, self) {
      return index === self.indexOf(elem);
  })}  placeholder="Seleziona..." />
      return c;
break;
case "Libretto Uso/Manutenzione":
case "Marcatura CE":
 
     c =<Dropdown value={(item.val)} onChange={(e) => handleChange(e,item.id)} options={["Presente","Assente"]} placeholder="Seleziona..." />
      return c;
break;



}

}




const handleCboxChange = (e,id) => {

  var dpiSelezionati = [...currentDpi]; // popolo l'array 
  if(e.target.checked){
  dpiSelezionati.push(id.toString());
  }else {
    const index = dpiSelezionati.indexOf(id.toString());
    if (index > -1) {
      dpiSelezionati.splice(index, 1); // 2nd parameter means remove one item only
    }
    
  }
  setCurrentDpi(dpiSelezionati);


}


return( 
    <>
 
    <CButton onClick={() => setVisible(!visible)}>{props.title}</CButton>
    <CModal alignment="center" size="lg" visible={visible}  onClose={() => setVisible(false)}>
      <CModalHeader>
        <CModalTitle>{props.title}</CModalTitle>
      </CModalHeader>
      <CModalBody>



 {
 
  data.length ===0? 
  dpi.map((dpiSelezionato) => 
  
  <CFormCheck onChange={(e) => handleCboxChange(e,dpiSelezionato.ID)} key={dpiSelezionato.id} label={dpiSelezionato.TipologiaDPI} checked={currentDpi.includes(dpiSelezionato.ID.toString())?true:false}/>
  )
  
  
  
  
  :(


    props.tipologia ==="Attrezzature"? //perchè attrezzature ha bisogno di cose diverse
    
    (

      data.map((item) => 

 
<div key={item.id} className="form-outline mb-4">
{item.text==="ID"?"":<label className="form-label">{item.text}</label>}
{ Renderswitch(item)}
</div>
)
                 
     
      
    


    )
    
    
    
    :
    
    
    (

  data.map((item) => 
 
   <div key={item.id} className="form-outline mb-4">
          {item.text==="ID"?"":<label className="form-label">{item.text}</label>}
          
          {item.text === "ID"?"":(item.text === "Descrizione" || item.text === "Note"  ?
           <CFormTextarea style={{height:"38px"}} type="text" name={item.text} value={item.val} className="form-control form-control-lg" onChange={(e) => handleChange(e,item.id)}/>
           :
           <input type="text" name={item.text} value={item.val} className="form-control form-control-lg" onChange={(e) => handleChange(e,item.id)}/>
          )}
          </div>
         
          ))
  )
 }
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={() => setVisible(false)}>
          Chiudi
        </CButton>
        <CButton color="primary" onClick={data.length ===0?((e) => handleConfirmCheckbox()):((e) => handleConfirm())} >Salva</CButton>
      </CModalFooter>
    </CModal>
  
  </>
  
)
};

export default MyModal;